import { CIcon } from '~/icons/types'

export const ciTrailers: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.5 13.023a.5.5 0 0 0-.5.5v.688h-2.319V6.96a.5.5 0 0 0-1 0V9.2H1v-1a.5.5 0 1 0-1 0v6.513a.5.5 0 0 0 .5.5h1.676a2.824 2.824 0 0 0 5.561 0h1.355a2.823 2.823 0 0 0 5.561-.007c.01 0 .019.006.029.006H23.5a.5.5 0 0 0 .5-.5v-1.19a.5.5 0 0 0-.5-.5ZM4.957 16.54a1.83 1.83 0 1 1 0-3.662 1.83 1.83 0 0 1 0 3.662Zm6.916 0a1.83 1.83 0 1 1-.002-3.661 1.83 1.83 0 0 1 .002 3.66Zm7.808-2.331h-5c-.01 0-.019.005-.029.006a2.823 2.823 0 0 0-5.561 0H7.737a2.823 2.823 0 0 0-5.56 0H1V10.2h18.681v4.009Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'trailers',
  type: 'thin'
}
